/* External */
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

/* Ott-common */
import { getMSOProviderFormatted, getUserTypeByBusinessUnit } from '@dtvgo/utils';

/* Utils */
import { useLanguage } from '../../providers/ConfigProvider/ConfigProvider';
import { useUserAccount } from '../../providers/UserProvider';
import platform from '../platform';
import { getGtmPlatform } from './utils';
import { APP_THEME } from '../env';
import { FREE_ACCOUNT, BUSINESS_CAMPAIGN } from '../constants';
import {
  getCookieByName,
  getProfileCustomAge,
  getProfileUnratedContent,
} from '../functions';

/* Storage */
import { selectProfileSelected } from '../../storage/profiles/selectors';
import { setSelectProfile } from '../../storage/profiles/actions';

const SELECT_PROFILE = 'profile';

const useGoogleTagsCommon = () => {
  const userAccount = useUserAccount();
  const language = useLanguage();
  const location = useLocation();
  const dispatch = useDispatch();
  const selectedProfile = useSelector(selectProfileSelected);
  const gtmPlatform = getGtmPlatform(platform?.aemPlatform);
  const profileEdited = location.state?.profileEditedData;
  const msoFormatted = getMSOProviderFormatted({
    msoProvider: userAccount?.msoProvider,
    businessUnit: userAccount?.businessUnit,
  });

  if (!selectedProfile && localStorage.getItem(SELECT_PROFILE)) {
    const profileSelected = JSON.parse(localStorage.getItem(SELECT_PROFILE));
    dispatch(setSelectProfile(profileSelected));
  }

  const loginType = BUSINESS_CAMPAIGN.has(userAccount?.msoProvider)
    ? FREE_ACCOUNT
    : getUserTypeByBusinessUnit(userAccount?.businessUnit);

  /*
    The v_client_id field was changed because it
    was sending the devideID as a client_id parameter,
    while other platforms are sending
    the customerId that comes in the user's login token.
  */
  return {
    v_client_id: getCookieByName('_ga'),
    v_user_id: userAccount?.uid,
    v_billing_status: userAccount?.customerStatus.toLowerCase(),
    v_profile_custom_age: getProfileCustomAge(profileEdited, selectedProfile),
    v_mso: msoFormatted?.toLowerCase() || undefined,
    v_language: language,
    v_app_name: `${APP_THEME}-${gtmPlatform}`,
    v_profile_unrated_content: getProfileUnratedContent(profileEdited, selectedProfile),
    v_login_type: loginType?.toLowerCase(),
    v_profile_id: (profileEdited)
      ? profileEdited?.profile_id : selectedProfile?.id,
    v_admin_profile: selectedProfile?.isMainProfile?.toString() || 'false',
    v_betting_enable: selectedProfile?.interactivities?.isBetAllowed?.toString() || 'false',
    v_isocode: userAccount?.iso2Code?.toLowerCase(),
  };
};

export default useGoogleTagsCommon;
